// extracted by mini-css-extract-plugin
export default {"basic_input":"basic_input___OZfru","label":"label___ERUmF","wrapper":"wrapper___gcWkL","is_error":"is_error___KGzMK","is_disabled":"is_disabled___tHS3g"};